/* @flow */

import { type Address } from './types';
import { type Endereco } from '../enderecos/types';
import formatarEndereco from '../enderecos/formatar-endereco';

const converterEnderecoEmAddress = (endereco: Endereco): Address => ({
    address: formatarEndereco(endereco),
    complement: endereco.complemento,
});

export default converterEnderecoEmAddress;
